import React, { Component } from 'react';
import moment from 'moment';
import DatetimeTableCell from '../DatetimeTableCell/DatetimeTableCell';

export default class BetResultLegendTable extends Component {
  getSortedData() {
    return this.props.data
      .sort((a, b) => +moment(a[4]) - +moment(b[4]));
  }

  static renderCell(a, i) {
    if (i === 4) return <DatetimeTableCell key={i} date={a} />;
    if (typeof a === 'string' && a.indexOf('€') === 0) return BetResultLegendTable.renderCurrencyCell(a, i);

    return <td key={i}>{a}</td>;
  }

  static renderCurrencyCell(val, i) {
    const decimalVal = parseFloat(val.substr(1));
    const cellVal = Number.isNaN(decimalVal) ? val : `€${decimalVal.toLocaleString('en-GB', { maximumFractionDigits: 2 })}`;

    return <td key={i}>{cellVal}</td>;
  }

  render() {
    return (
      <table className="table table-hover">
        <thead>
          <tr>
            <th>Bet type</th>
            <th>Stake</th>
            <th>Price</th>
            <th>Bookie</th>
            <th>Placed at</th>
          </tr>
        </thead>
        <tbody>
          {this.getSortedData().map(arr => (
            <tr key={`${arr[0]}_${arr[1]}_${arr[4]}`}>
              {arr.map(BetResultLegendTable.renderCell)}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/BetResultLegendTable/BetResultLegendTable.js